module.exports = __webpack_public_path__ + "assets/4-what-does-a-sales-manager-do.5a205463.png";